import injectSheet from 'react-jss';

import Uicon from './component';
import styles from './styles';

export default injectSheet(styles)(Uicon);
